import { Formik } from "formik";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { migrate_from_shop_to_toshop } from "../../services/migration.services";
import { validationMigration } from "../Shop/Shop.validation";
import MigrationForm from "./Forms/MigrationForm";

const initialState = {
  from_shop_username: "",
  to_shop_username: "",
  category: false,
  diningtable: false,
  fooditem: false,
  expense_category: false,
  inventory_category: false,
};

const Shop = (props: any) => {
  const [loader, setLoader] = useState(false);
  const handleStepSubmit = async (value: any) => {
    const data: any = {
      from_shop_username: value?.from_shop_username,
      to_shop_username: value.to_shop_username,
      metadata: {
        category: value.category,
        diningtable: value.diningtable,
        fooditem: value.fooditem,
        expense_category: value.expense_category,
        inventory_category: value.inventory_category,
      },
    };
    setLoader(true);
    migrate_from_shop_to_toshop(data)
      .then((res: any) => {
        setLoader(false);
        console.log("status", res);
        if (res?.data?.status == 200) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.message);
      });
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleStepSubmit(values)}
        enableReinitialize={true}
        initialValues={initialState}
        validate={(values) => {
          return validationMigration(values);
        }}
      >
        {({
          handleSubmit,
          values,
          handleChange,
          errors,
          setFieldValue,
          touched,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="content-box">
                <div className="content-body">
                  <div>
                    <MigrationForm
                      handleChange={handleChange}
                      errors={errors}
                      values={values}
                      touched={touched}
                    />
                    <div className="px-2 py-4 d-flex justify-content-center">
                      <button
                        disabled={loader}
                        className="btn btn-primary primary-out"
                        type="submit"
                      >
                        Migrate Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </>
        )}
      </Formik>
    </>
  );
};

export default Shop;
